export default "__VITE_ASSET__D10Y65YQ__"